import { useEffect, useState } from "react";
import { Sheet } from "../../components/ui";
import type { TodayChannelEncounterThread } from "../../services/channel-encounter-api";
import type { ChannelEncounterMemoryView } from "../../services/me-api";
import { ReadOnlyConversationLog } from "../chat/ReadOnlyConversationLog";
import { MemoryFragmentViewer } from "../memory/MemoryFragmentViewer";
import "./channel.css";

/**
 * 站外对话的统一只读展开层。首页的今日气泡和回忆点滴里的历史条目都使用它，
 * 避免两处消息气泡、引用消息与头像规则逐渐分叉。
 */
export function ChannelConversationSheet({
  open,
  title,
  threads,
  hasEarlier,
  memory = null,
  speakerName,
  avatarUrl,
  onClose,
}: {
  open: boolean;
  title: string;
  threads: readonly TodayChannelEncounterThread[];
  hasEarlier: boolean;
  /** 历史页才有；首页今天的站外对话尚未到夜间摘要时刻。 */
  memory?: ChannelEncounterMemoryView | null;
  speakerName: string;
  avatarUrl: string | null;
  onClose: () => void;
}) {
  const [memoryOpen, setMemoryOpen] = useState(false);

  useEffect(() => {
    if (!open) setMemoryOpen(false);
  }, [open]);

  return (
    <Sheet open={open} title={title} onClose={onClose}>
      {open ? (
        <div className="channel-encounter">
          {memory ? (
            <MemoryFragmentViewer
              memory={memory}
              open={memoryOpen}
              showTitle
              onOpen={() => setMemoryOpen(true)}
              onClose={() => setMemoryOpen(false)}
            />
          ) : null}

          {hasEarlier ? (
            <p className="inline-hint">这一天聊得很多，这里先显示最近的消息。</p>
          ) : null}

          {threads.map((thread) => (
            <section className="channel-encounter__thread" key={thread.id}>
              <h3 className="channel-encounter__scope">{thread.scopeLabel}</h3>
              <ReadOnlyConversationLog
                messages={thread.messages}
                speakerName={speakerName}
                avatarUrl={avatarUrl}
              />
            </section>
          ))}
        </div>
      ) : null}
    </Sheet>
  );
}
